export function getMCQScore(question){
    if(!question?.options)return 0
    const isSingleChoice = question?.multipleChoiceType!=='多項選擇題'

    if(isSingleChoice){
        for(let i of question.options){
            if(i.correct && i.isSelected){
                return Number(question.score)
            }
        }
        return 0
    }else{
        let correctCount=0
        for(let i of question.options){
            if(i.correct && i.isSelected){
                correctCount++
            }else if((!i.correct) && (!i.isSelected)){
                correctCount++
            }
        }
        return Math.round(correctCount/question?.options.length*Number(question.score)*10)/10
    }
}

export function getTableScore(question){
    let correctCount=0
    for(let row of (question.table||[])){
        if(((!!row.correct1)===(!!row.answer1)) && ((!!row.correct2)===(!!row.answer2))){
            correctCount++
        }
    }
    return correctCount/question?.table.length*Number(question.score)
}

export function getDragAndDropScore(question){
    let correctCount=0
    let questionCount=0
    for(let col of (question?.dragAndDrop||[])){
        for( let row of col.rows){
            if(row.type==='拖放格'){
                questionCount++
                if(row.answer===row.studentAnswer)
                    correctCount++
            }
        }
    }
    return correctCount/questionCount*Number(question.score)
}
export function getMarkingScore(question){
    return question?.markingScore||0
}

export function getStudentScore(questions){
    let totalScore=0
    for(let question of (questions||[])){
        if(question.type==='選擇題'){
            totalScore+=getMCQScore(question)
        }else if(question.type==='表格問題'){
            totalScore+=getTableScore(question)
        }else if(question.type==='拖放式問題'){
            totalScore+=getDragAndDropScore(question)
        }else if(question.type==='選擇題 + 短句作答題'||question.type==='短句作答題'){
            totalScore+=getMarkingScore(question)
        }
    }
    return totalScore
}
export function getTotalScore(questions){
    if(!questions)return 99
    
    let totalScore=0
    for(let question of (questions||[])){
        totalScore+=Number(question.score)||0
    }
    return totalScore
}
export function getQuestionScore(question){
    if(question.type==='選擇題'){
        return getMCQScore(question)
    }else if(question.type==='表格問題'){
        return getTableScore(question)
    }else if(question.type==='拖放式問題'){
        return getDragAndDropScore(question)
    }else if(question.type==='選擇題 + 短句作答題'||question.type==='短句作答題'){
        return getMarkingScore(question)
    }
    return 0
}
export function getTimeToComplete(mission){
    if((!mission?.startTime)||(!mission?.finishTime))return 0
    let mm = Math.floor((new Date(mission.finishTime)-new Date(mission.startTime))/60000)
    let ss = Math.floor((new Date(mission.finishTime)-new Date(mission.startTime))/1000)%60
    if(ss<10)ss='0'+ss
    return mm+':'+ ss
}
